import { IconSizeType } from "@/lib/types";
import { CSSProperties } from "react";

type Props = {
  count: number;
  size?: IconSizeType;
};

export default function BadgeCounter({ count, size }: Props) {
  if (!size) size = "lg";

  const containerStyle: CSSProperties = {
    position: "absolute",
    top: `calc(var(--svg-size-icon-${size}) * -3 / 7)`,
    right: `calc(var(--svg-size-icon-${size}) * -3 / 8)`,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: `var(--badge-size-${size})`,
    padding: `0 calc(var(--badge-size-${size}) / 4)`,
    minWidth: `var(--badge-size-${size})`,
    height: `var(--badge-size-${size})`,

    background: "var(--color-background-danger)",
  };

  const countStyle: CSSProperties = {
    color: "var(--color-text-always-light)",
    fontSize: `calc(var(--badge-size-${size}) * 3 / 4)`,
    lineHeight: 1,
  };

  return (
    <>
      {count > 0 ? (
        <div style={containerStyle}>
          <p style={countStyle}>{count > 99 ? "99+" : count}</p>
        </div>
      ) : null}
    </>
  );
}
